import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResumeComponent } from '../resume/resume.component';
import { GeopositionModule } from 'libraries/service/geoposition/geoposition.module';
import { HostAliasPipeModule } from "libraries/pipes/host-alias/host-alias-pipe.module";
import { GeoPositionPipesModule } from "libraries/pipes/geo-position/geo-position-pipes.module";
import {PermissionModule} from "../../permission/permission.module";
import { DatePipeModule } from "libraries/date/date.module";

@NgModule({
    declarations: [
        ResumeComponent,
    ],
    imports: [
        CommonModule,
        GeopositionModule,
        HostAliasPipeModule,
        GeoPositionPipesModule,
        PermissionModule,
        DatePipeModule,
    ],
    exports: [
        ResumeComponent,
    ],
    providers: [],
})
export class ResumeModule {}
